import classNames from 'classnames'

import Image from '../ui/Image/Image'
import Card from '../ui/Card/Card'
import HeaderScrollHandler from '../HeaderScrollHandler/HeaderScrollHandler'
import Markdown from '../Markdown/Markdown'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import useHorizontalScroll from '../../hooks/useHorizontalScroll'

import { getImageUrl, isArabic } from '../../utils'
import styles from './RupayLayout.module.scss'

function RupaySuccess({ title, description, cardHeader, cards = [] }) {
  const { language } = useLanguage()
  const { scrollRef, scrollLeft, scrollRight, isAtStart, isAtEnd } =
    useHorizontalScroll(600)
  return (
    <div className={styles.successContainer}>
      <div className={classNames('page-container', styles.successHeader)}>
        <h2>{title}</h2>
        <Markdown
          content={description}
          className={styles.descriptionRichText}
        />
      </div>
      <div
        className={classNames(styles.bottomContainer, {
          [styles.arabicBottomContainer]: isArabic(language?.code),
        })}
      >
        <HeaderScrollHandler
          subTitle={cardHeader}
          scrollLeft={scrollLeft}
          scrollRight={scrollRight}
          isAtEnd={isAtEnd}
          isAtStart={isAtStart}
          className={classNames('page-container', styles.successCardHeader)}
          subTitleClass={styles.successSubtitle}
        />
        <div
          className={classNames(styles.successCardContainer)}
          ref={scrollRef}
        >
          {cards.map((item) => (
            <Card key={'keyfeatures' + item?.id} className={styles.successCard}>
              <Image
                src={getImageUrl(item.image)}
                alt={item?.image?.alternativeText}
              />
              <div className={styles.successCardDetails}>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default RupaySuccess
